'use client';
import * as React from 'react';

export const GridConfigurationContext = React.createContext<unknown>(undefined);
